import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const labelVariants = cva(
  "peer-disabled:cursor-not-allowed peer-disabled:opacity-40",
  {
    variants: {
      variant: {
        /** Label padrao: Geist Sans, normal */
        default: "text-sm font-medium text-foreground leading-none",
        /** Label editorial: 11px uppercase tracking-wide - identidade bento */
        editorial: "label-editorial",
        /** Label de campo de formulario com caractere editorial */
        field: [
          "text-xs font-medium uppercase tracking-[0.08em]",
          "text-muted-foreground",
          "leading-none",
        ].join(" "),
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {}

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ variant }), className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
